import { useRecoilValue } from 'recoil';
import classNames from 'classnames';

import { MenuItemConfig } from 'common/types';
import Dropdown from 'components/common/Dropdown/Dropdown';
import Link from 'components/common/Link/Link';
import { viewState } from 'components/common/Managers/ViewStateManager.state';
import { getViewUrlState } from 'components/common/Managers/RouteStateManager.state';
import { views } from 'views';

import './ViewSelector.scss';

type ViewSelectorProps = {
  crossTeamSearchEnabled: boolean;
};

/**
 * This component provides a dropdown that can be used to switch among available views.
 *
 * @prop crossTeamSearchEnabled    if true, cross-team search is enabled (affects layout)
 */
const ViewSelector = ({ crossTeamSearchEnabled }: ViewSelectorProps) => {
  const currentView = useRecoilValue(viewState);
  const getViewUrl = useRecoilValue(getViewUrlState);

  const orderedViews = Object.values(views).sort((viewA, viewB) => viewA.order - viewB.order);

  // TODO: Discuss with PMs / Design if we should have Standard view when there are custom views available
  const viewsToShow: MenuItemConfig[] = [
    ...orderedViews.map((view) => ({
      active: currentView.name === view.name,
      // We build the URL even for the currently selected view, if we pass `undefined`, the underlying
      // component will interpret it as `/`
      href: getViewUrl(view),
      name: view.name,
      text: view.label,
    })),
  ];

  return (
    <Dropdown
      className={classNames('ViewSelector', crossTeamSearchEnabled ? 'ViewSelector__NoLeftRoundedCorners' : '')}
      itemAs={Link}
      sections={[viewsToShow]}
      size="med"
    >
      {currentView.label}
    </Dropdown>
  );
};

export default ViewSelector;
